export default __webpack_public_path__ + "static/media/top-right1.3c0aa355.png";